/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export interface QuoteRequestData {
  accountNumber: string;
  branchId?: string;
  productId: number;
  quantity: number;
  name: string;
  email: string;
  phone: string;
  notes?: string;
}

export enum QuoteModalType {
  OFFER = "OFFER",
  ENQUIRY = "ENQUIRY",
  QUOTE_CART = "QUOTE_CART",
  QUOTE_SINGLE = "QUOTE_SINGLE",
}
